import { render } from "./ScoreboardPhoneticTranscription.vue?vue&type=template&id=a082bf9c&scoped=true"
import script from "./ScoreboardPhoneticTranscription.vue?vue&type=script&lang=js"
export * from "./ScoreboardPhoneticTranscription.vue?vue&type=script&lang=js"

import "@/css/components/scoreboard-phonetic-transcription.css?vue&type=style&index=0&id=a082bf9c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a082bf9c"]])

export default __exports__